/**
 * BerryPeek
 * Web client for BerryPeek v4
 * @author  biohzrdmx <github.com/biohzrdmx>
 * @copyright Copyright (c) 2022 BerryPeek. All rights reserved
 */

import "./vendor/plugins.js"

import { BerryPeek } from './src/BerryPeek.js';

// Get BerryPeek instance
window.berrypeek = new BerryPeek();